import type { Suggestion } from "@divespots/contracts";
import { pickLocale } from "@divespots/contracts";
import type { Locale } from "@divespots/contracts";
import { useTranslation } from "react-i18next";

const CHIP: Record<Suggestion["status"], string> = {
  pending: "ds-badge",
  approved: "ds-badge ds-badge--object",
  rejected: "ds-badge ds-badge--closed",
  withdrawn: "ds-badge",
};

/** pending / approved / rejected / withdrawn as a tinted status chip. */
export function StatusChip({ status }: { status: Suggestion["status"] }) {
  const { t } = useTranslation();
  return <span className={CHIP[status]}>{t(`suggest.status.${status}`)}</span>;
}

/** A readable one-line title: the proposed name for creates, the kind for edits. */
export function suggestionTitle(s: Suggestion, locale: Locale, t: (k: string) => string): string {
  if (s.kind === "spot_create") return s.payload.name;
  if (s.kind === "object_create") {
    return pickLocale(s.payload.name, locale) ?? t(`suggest.kind.${s.kind}`);
  }
  return t(`suggest.kind.${s.kind}`);
}
